var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"charts"},[_c('div',{staticClass:"chart",staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"chart"}},[_vm._v("Chart Loading")])]):_c('div',{staticClass:"nodata value"},[_vm._v(_vm._s(_vm.$t('nodata')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }